import React from "react";
import { LoadingButton as MuiLoadingButton } from "@mui/lab";

const LoadingButton = (props) => {
  return <MuiLoadingButton {...props} />;
};

export default LoadingButton;
